import React from 'react';
import classnames from 'classnames';

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ children, className, sideClassName, style }) => (
  <div style={style} className={classnames(sideClassName, className)}>
    {children}
  </div>
);
